<div class="info-header-container">
  <div class="detail-header-container">
    <div class="info-grid">
      <div class="left-section">
        <div class="info-item">
          <span class="label">Cliente:</span>
          <span class="value">{{
            data()?.createdByUser?.organization?.name || "Geoambiente"
          }}</span>
        </div>
        @if (isCancelled) {
          <!-- Motivo do cancelamento para CANCELADO -->
          <div class="info-item reason">
            <span class="label">Motivo do cancelamento:</span>
            <div class="cancellation-reason">{{ data()?.error }}</div>
          </div>
          <div class="info-item reason">
            <span class="label">Data de cancelamento: </span>
            <div class="value">
              {{ data()?.lastModifiedDate | date: "dd/MM/yyyy HH:mm" }}
            </div>
          </div>
          <div class="info-item reason">
            <span class="label">Cancelado por:</span>
            <div class="value">{{ data()?.lastModifiedByUser?.email }}</div>
          </div>
        }

        @if (!isCancelled) {
          <!-- Status para VALIDANDO e CONCLUÍDO -->
          <div class="info-item status-item">
            <span class="label">Status da solicitação:</span>
            <span class="value">{{ data()?.status?.description }}</span>
          </div>
        }

        <!-- Timeline sempre presente -->
        <div class="timeline-item">
          <div class="timeline-label">Data do evento:</div>

          <div class="timeline-content">
            <div class="timeline-item">
              <div class="timeline-marker start"></div>
              <span class="timeline-text">
                <b>INÍCIO:</b>
                {{ data()?.createdDate | date: "dd/MM/yyyy HH:mm" }}
              </span>
            </div>

            <div class="timeline-line"></div>

            <div class="timeline-item">
              <div class="timeline-marker end"></div>
              <span class="timeline-text">
                <b>TÉRMINO:</b>
                {{ data()?.lastModifiedDate | date: "dd/MM/yyyy HH:mm" }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="right-section">
        <div class="info-item">
          <span class="label">Safra:</span>
          <span class="value">{{ data()?.cropYear || "N/A" }}</span>
        </div>
        <div class="info-item">
          <span class="label">Cultura:</span>
          <span class="value">{{
            data()?.targetCulture?.description || "N/A"
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">N° de áreas monitoradas:</span>
          <span class="value">{{ data()?.totalAreaCount || "N/A" }}</span>
        </div>
        <div class="info-item">
          <span class="label">Área total (ha):</span>
          <span class="value">{{ data()?.totalAreaHa || "N/A" }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Botões de ação apenas para status VALIDATING -->
  @if (isValidating) {
    <div class="buttons-section">
      <button mat-stroked-button (click)="modalCancelamento()">
        Cancelar Solicitação
        <mat-icon>arrow_back</mat-icon>
      </button>

      <button
        [disabled]="!canUpload()"
        mat-flat-button
        (click)="onUploadFile()"
      >
        Upload de arquivo
        <mat-icon>save</mat-icon>
      </button>
    </div>
  }
</div>

<hr />
